import Vue from 'vue';

export default {
    namespaced: true,

    state: () => ({
        participants: {}
    }),

    mutations: {
        APPEND_PARTICIPANT(state, participant) {
            if (!(participant.peer_id in state.participants)) {
                Vue.set(state.participants, participant.peer_id, participant);  // required for reactivity
            }
        },

        REMOVE_PARTICIPANT(state, peer_id) {
            if (peer_id in state.participants) {
                Vue.delete(state.participants, peer_id);
            }
        },

        SET_MEDIASTREAM(state, data) {
            if (data.peer_id in state.participants) {
                state.participants[data.peer_id].mediaSource = data.mediaSource;
            }
        },

        SET_PEERSTATE(state, data) {
            if ((data.peer_id in state.participants)) {
                state.participants[data.peer_id].userData.peerState = {...state.participants[data.peer_id].userData.peerState, ...data.value};
            }
        },

        SET_PEERSTATS(state, data) {
            if ((data.peer_id in state.participants)) {
                state.participants[data.peer_id].stats = data.stats;
            }
        },
    },

    getters: {
        allParticipants(state) {
            return state.participants;
        },

        // return other groups of filtered participants here
    },

    actions: {
        addParticipant({commit}, participant) {
            // do validation etc here...
            commit('APPEND_PARTICIPANT', participant);
        },

        removeParticipant({commit}, peer_id) {
            commit('REMOVE_PARTICIPANT', peer_id);
        },
    },
}